import { render, staticRenderFns } from "./playerSetup.vue?vue&type=template&id=ac0c1d40&scoped=true&"
import script from "./playerSetup.vue?vue&type=script&lang=js&"
export * from "./playerSetup.vue?vue&type=script&lang=js&"
import style0 from "./playerSetup.vue?vue&type=style&index=0&id=ac0c1d40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0c1d40",
  null
  
)

export default component.exports